import { Box, Tag, Tooltip, TooltipContent, TooltipTrigger } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export function RecognitionGiftDisabledTag() {
  const { t } = useTranslation();

  return (
    <Tooltip>
      <TooltipTrigger asChild={true}>
        <Box className={"w-fit cursor-help"}>
          <Tag variant={"warning"}>{t("recognition:gift_disabled_tag")}</Tag>
        </Box>
      </TooltipTrigger>
      <TooltipContent className={"max-w-60"}>{t("recognition:gift_disabled_hint")}</TooltipContent>
    </Tooltip>
  );
}
